"use strict";

var flatten = require('lodash/flatten');

var get = require('lodash/get');

var PrintJob = require('./PrintJob');

var getComposables = require('./PrintingDetails/componentComposables');

var DeluxeProgramInteriorPage = require('../products/components/DeluxeBookletProgramInterior');

var _require = require('./helpers'),
    isLetterpressComponent = _require.isLetterpressComponent,
    isPaperComponent = _require.isPaperComponent;

function testPrintsPriceEstimation(printJob, product, component, componentSettings) {
  var component_type = component.type;
  var component_options = componentSettings[component_type] || componentSettings["default"];

  if (!component_options.pricingLabelText) {
    return [];
  }

  var fields = [{
    field: 'pricingLabelText',
    value: getComposables('pricingLabelText', component_options.pricingLabelText).reduce(function (accumulator, fn) {
      return fn(accumulator, printJob, product, component, component_options, componentSettings);
    }, '')
  }, {
    field: 'printingCost',
    value: 1
  }, {
    field: 'shrinkWrappingCost',
    value: 0
  }];
  return fields;
}

function priceEstimation(printJob, product, component, componentSettings) {
  var component_type = component.type;
  var component_options = componentSettings[component_type] || componentSettings["default"];
  var fields = [];

  if (Object.prototype.isPrototypeOf.call(DeluxeProgramInteriorPage.prototype, component)) {
    fields = [];
  } else if (component_type.match(/envelope$/i)) {
    fields = [{
      field: 'pricingLabelText'
    }, {
      field: 'printingCost',
      number: true
    }, {
      field: 'coloredInkUpcharge',
      number: true
    }, {
      field: 'shrinkWrappingCost',
      number: true
    }];
  } else {
    fields = [{
      field: 'pricingLabelText'
    }, {
      field: 'printingCost',
      number: true
    }, {
      field: 'shrinkWrappingCost',
      number: true
    }];
  }

  fields.forEach(function (_ref, index) {
    var field = _ref.field,
        number = _ref.number;

    if (!component_options[field]) {
      throw new Error("".concat(field, " did not yield any options for component type ").concat(component_type));
    }

    var value = getComposables(field, component_options[field]).reduce(function (accumulator, fn) {
      return fn(accumulator, printJob, product, component, component_options, componentSettings);
    }, '');

    if (number) {
      var n = parseFloat(value, 10);

      if (Number.isNaN(n)) {
        fields[index].value = 0;
      } else {
        fields[index].value = n;
      }
    } else {
      fields[index].value = value;
    }
  });
  return fields;
}

function estimateProductPrintingCostBreakdown(product, printJob, printerName, variant, options) {
  var negotiatedPricing = get(options, ['printers', printerName, 'negotiatedPrices', product.type]);
  var componentSettings = get(options, ['printers', printerName, 'components']);
  var f;

  switch (variant) {
    case 'TestPrints':
      f = testPrintsPriceEstimation;
      break;

    default:
      f = priceEstimation;
      break;
  }

  if (negotiatedPricing) {
    return negotiatedPricing;
  }

  var filter;

  switch (printerName) {
    case 'pistachioPress':
      filter = isLetterpressComponent;
      break;

    default:
      filter = function filter(comp) {
        return isPaperComponent(comp) && !isLetterpressComponent(comp);
      };

      break;
  }

  return product.subcomponents().filter(filter).map(function (component) {
    return f(printJob, product, component, componentSettings, options);
  });
}

function estimateProductPrintingCost(product, printJob, printerName, variant, options) {
  var lineItems = estimateProductPrintingCostBreakdown(product, printJob, printerName, variant, options).filter(function (arr) {
    return arr.length;
  });
  var total_price = 0;
  var total_printing_cost = 0;
  var total_shrink_wrapping_cost = 0;
  lineItems.forEach(function (fields) {
    var sum = fields[1].value + fields[2].value;
    total_price += sum;
    total_printing_cost += fields[1].value;
    total_shrink_wrapping_cost += fields[2].value;
  });
  return {
    breakdown: lineItems,
    total: total_price,
    printing: total_printing_cost,
    shrinking: total_shrink_wrapping_cost
  };
}

function estimatePrintJobPrintingCost(printJob, printerName, variant, options) {
  if (!Object.prototype.isPrototypeOf.call(PrintJob.prototype, printJob)) {
    throw new Error('printJob must be an instance of PrintJob');
  }

  if (!printerName) {
    throw new Error('printerName is required');
  }

  var lineItemsNestedArray = printJob.products.map(function (product) {
    return estimateProductPrintingCostBreakdown(product, printJob, printerName, variant, options);
  });
  var lineItems = flatten(lineItemsNestedArray).filter(function (arr) {
    return arr.length;
  });
  var total_price = 0;
  var total_printing_cost = 0;
  var total_ink_color_upcharge = 0;
  var total_shrink_wrapping_cost = 0;
  lineItems.forEach(function (fields) {
    if (fields.length === 3) {
      var sum = fields[1].value + fields[2].value;
      total_price += sum;
      total_printing_cost += fields[1].value;
      total_shrink_wrapping_cost += fields[2].value;
    }

    if (fields.length === 4) {
      var _sum = fields[1].value + fields[2].value + fields[3].value;

      total_price += _sum;
      total_printing_cost += fields[1].value;
      total_ink_color_upcharge += fields[2].value;
      total_shrink_wrapping_cost += fields[3].value;
    }
  });
  return {
    breakdown: lineItems,
    total: total_price,
    printing: total_printing_cost,
    shrinking: total_shrink_wrapping_cost,
    ink: total_ink_color_upcharge
  };
}

module.exports = {
  estimateProductPrintingCost: estimateProductPrintingCost,
  estimatePrintJobPrintingCost: estimatePrintJobPrintingCost
};